const FILTERED = "[Filtered]";

// Param names in this app never contain "+"; decoding is only needed to match
// percent-encoded Ransack keys like q%5Bfirst_name_cont%5D against the patterns.
const safeDecodeKey = (raw: string): string => {
  try {
    return decodeURIComponent(raw);
  }
  catch {
    return raw;
  }
};

// On masque tout param dont la valeur est du texte libre humain ou un attribut de
// personne (peut porter un nom). Enums, statuts, IDs, dates, booléens restent visibles :
// ils identifient des objets métier, pas des personnes, et gardent leur valeur de debug.
export const SENTRY_SCRUBBED_PARAM_PATTERNS: readonly RegExp[] = [
  /^search$/, //           recherches texte libre (toutes features)
  /Search$/, //            employeeLastNameSearch (beneficiaries)…
  /^af$/, //               advanced filters (refund-requests / ecom-orders) — valeur libre
  /^ca$/, //               custom attributes (employees) — valeurs libres
  /^author$/, //           blog — filtre auteur, texte libre
  /^firstName$/, //        employees — littéralement un prénom
  /^lastName$/, //         employees — littéralement un nom
  /^employee$/, //         refund-requests — id pseudonymisé, masqué par cohérence (coût nul)
  /^auditableEmployeeId$/, // audit-logs — id salarié scope audité, masqué par cohérence
  // Recherches Ransack des appels API GET (breadcrumbs fetch/xhr). Couvre :
  //   *_cont / *_i_cont / *_cont_any / *_cont_all   — substring
  //   *_start / *_i_start / *_start_any / *_start_all — prefix
  //   *_matches / *_i_matches                        — LIKE
  //   *_search (scopes personnalisés : smart_search, employee_last_name_search…)
  /^q\[.*(?:_i?_?cont|_i?_?start|_i?_?matches|_search).*\]$/,
];

/**
 * Replaces the VALUE of every query param whose NAME matches a pattern with
 * `[Filtered]`, leaving all other params byte-identical. Accepts absolute or
 * relative URLs (and bare paths); a string without a query is returned
 * unchanged. Never throws — a malformed input is returned as-is.
 */
export const scrubUrlParams = (url: string, patterns: readonly RegExp[]): string => {
  const hashIndex = url.indexOf("#");
  const hash = hashIndex === -1 ? "" : url.slice(hashIndex);
  const head = hashIndex === -1 ? url : url.slice(0, hashIndex);

  const queryIndex = head.indexOf("?");
  if (queryIndex === -1) return url;

  const base = head.slice(0, queryIndex);
  const query = head.slice(queryIndex + 1);
  if (!query) return url;

  const scrubbed = query
    .split("&")
    .map((pair) => {
      const eq = pair.indexOf("=");
      const rawKey = eq === -1 ? pair : pair.slice(0, eq);
      const key = safeDecodeKey(rawKey);
      return patterns.some((pattern) => pattern.test(key)) ? `${rawKey}=${FILTERED}` : pair;
    })
    .join("&");

  return `${base}?${scrubbed}${hash}`;
};
